// extracted by mini-css-extract-plugin
module.exports = {"single_select_page":"single-select-page_single_select_page__vmkop"};